"use client";

import ApiPath from "@/network/api/apiPath";
import NetworkService from "@/network/service/networkService";
import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const network = new NetworkService();
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const pathname = usePathname();

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const res = await network.globalGet(ApiPath.allSettings);
      if (res?.status === "completed") {
        setSettings(res?.data || null);
      } else {
        setSettings(null);
      }
    } catch (error) {
      console.error("Failed to fetch settings:", error);
      setSettings(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Re-fetch settings on every route change
  useEffect(() => {
    if (pathname.startsWith("/dashboard/settings")) {
      fetchSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <SettingsContext.Provider value={{ settings, isLoading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used inside SettingsProvider");
  }
  return context;
};
